import { Col, Row, Table } from "reactstrap";
import {
  BreadIcon,
  PlatterIcon,
  ShakesIcon,
} from "../../assets/designedPickedIcons";
import {
  dummyApetizers,
  dummyBreads,
  dummyPlaces,
  dummyPlaters,
  dummyShakes,
} from "../../dummyData";
import hookahImg from "../../assets/Hookah.png";
import pizzaImg from "../../assets/pizza.png";
import saladImg from "../../assets/salad.png";
import dummyMenu from "../../assets/dummy-menu.png";
import { useSelector } from "react-redux";

const ResturantMenuCard = () => {
const placeDetail=useSelector((s) => s?.placeDetails ?? {});;
console.log("redux place-detail",placeDetail);

  return (
    <div>
      <h4
        style={{ letterSpacing: "4.5px" }}
        className="f-5 text-decoration-underline text-white mb-4 text-center"
      >
        Menu Card
      </h4>
      <div className="resturant-detail-div  ">
        <img
          src={placeDetail?.menuImages?.[0]}
          height={650}
          alt="menu"
          className="full-width object-fit-contain"
        />
      </div>
    </div>
  );
};

/*----------------------right now the menu is image if needed use this code---------------*/
{
  /* <Row className="g-4">
          <Col md={6} xxl={4}>
            <div className="bg-green-2 mb-3  bordered-primary-green rounded-sm p-2 d-flex align-items-center gap-2">
              <div
                style={{ height: 40, width: 40 }}
                className="bg-primary-green-3 d-flex align-items-center justify-content-center rounded-full"
              >
                <ShakesIcon />
              </div>
              <h5 className="m-0 f-6 full-width color-primary-green-3">
                MOCKTALES & SHAKES
              </h5>
            </div>
            <Table borderless>
              <tbody>
                {dummyShakes?.map((item, key) => (
                  <tr key={key} style={{ borderBottom: " 1px solid black" }}>
                    <td className="bg-transparent p-0">
                      <p className="f-6 m-0 color-primary-black-5">
                        {item?.title}
                      </p>
                    </td>
                    <td className="bg-transparent p-0  text-end">
                      <p className="f-5 m-0 color-primary-black-5">
                        {item?.price}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="bg-primary-red-2 mt-2 mb-4  bordered-primary-yellow rounded-sm  d-flex gap-2">
              <div>
                <img
                  src={hookahImg}
                  height={115}
                  width={69}
                  style={{ objectPosition: "right" }}
                  className="object-fit-cover"
                  alt="hookah"
                />
              </div>
              <div className="p-2">
                <h5 className="mb-2 f-6 full-width color-primary-yellow">
                  HERBAL FLAVOURED HOOKAH
                </h5>
                <div>
                  <div className="d-flex flex-wrap flex-md-nowrap align-items-center justify-content-between">
                    <small className="f-6 color-primary-black m-0">
                      RUSSIAN HOOKAH
                    </small>
                    <p className="f-5 color-primary-yellow my-0 mx-3 ">₹2000</p>
                  </div>
                  <div className="d-flex align-items-center flex-wrap flex-md-nowrap justify-content-between">
                    <small className="f-6 color-primary-black m-0">
                      KHALEEL HOOKAH
                    </small>
                    <p className="f-5 color-primary-yellow my-0 mx-3 ">₹2000</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-primary-yellow-1 mb-3 position-relative   border-primary-yellow rounded-sm d-flex gap-2 align-items-center">
              <h5 className="m-0 f-6 full-width p-2 color-primary-brown-2">
                PIZZAS VEG/NON VEG
              </h5>
              <img
                src={pizzaImg}
                height={75}
                width={75}
                style={{ right: 0, top: "-50%" }}
                className="object-fit-contain position-absolute"
              />
            </div>
            <Table>
              <tbody>
                {dummyShakes?.map((item, key) => (
                  <tr
                    key={key}
                    style={{
                      borderBottom: " 1px solid black",
                    }}
                  >
                    <td className="bg-transparent p-0">
                      <p className="f-6 m-0 color-primary-black-5">
                        {item?.title}
                      </p>
                    </td>
                    <td className="bg-transparent color-primary-black-5 p-0 text-end">
                      <p className="f-5 m-0">{item?.price}</p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
          <Col md={6} xxl={4}>
            <div className="bg-primary-brown-3 mb-3 bordered-primary-brown rounded-sm p-2 d-flex align-items-center gap-2">
              <div
                style={{ height: 40, width: 40 }}
                className="bg-primary-brown-4 d-flex align-items-center justify-content-center rounded-full"
              >
                <BreadIcon />
              </div>
              <h5 className="m-0 f-6 full-width color-primary-brown-4">
                PASTA & GARLIC BREAD
              </h5>
            </div>

            <Table borderless>
              <tbody>
                <tr style={{ borderBottom: " 1px solid black" }}>
                  <td className="bg-transparent p-0"></td>
                  <td className="bg-transparent p-0  color-primary-brown-4 f-6">
                    VEG
                  </td>
                  <td className="bg-transparent p-0 text-end  color-primary-brown-4 f-6">
                    N/VEG
                  </td>
                </tr>
                {dummyBreads?.map((item, key) => (
                  <tr key={key} style={{ borderBottom: " 1px solid black" }}>
                    <td className="bg-transparent p-0">
                      <p className="f-6 m-0 color-primary-black-5">
                        {item?.title}
                      </p>
                    </td>
                    <td className="bg-transparent p-0 color-primary-black-5">
                      <p className="f-5 m-0">{item?.vegPrice}</p>
                    </td>
                    <td className="bg-transparent p-0 text-end color-primary-black-5">
                      <p className="f-5 m-0">{item?.nonVegPrice}</p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <div className="bg-primary-cyan-1 mt-4 mb-2 bordered-primary-cyan rounded-sm p-2 d-flex justify-content-center align-items-center gap-2">
              <div
                style={{ height: 40, width: 40 }}
                className="bg-bluish-white d-flex align-items-center justify-content-center rounded-full"
              >
                <PlatterIcon />
              </div>
              <h5 className="m-0 f-6  color-bluish-white">PLATTERS</h5>
            </div>
            <Table borderless>
              <tbody className="p-0">
                {dummyPlaters?.map((item, key) => (
                  <tr key={key} style={{ borderBottom: " 1px solid black" }}>
                    <td className="bg-transparent p-0">
                      <p className="f-6 m-0 color-primary-black-5">
                        {item?.title}
                      </p>
                    </td>
                    <td className="bg-transparent p-0  text-end">
                      <p className="f-5 m-0 color-primary-black-5">
                        {item?.price}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="bg-primary-red-3 mt-4 mb-3 position-relative rounded-sm p-2 d-flex  align-items-center gap-2">
              <h5 className="m-0 f-6  color-bluish-white">APPETIZERS VEG</h5>
              <img
                src={saladImg}
                height={75}
                width={75}
                style={{ right: 0, top: "-60%" }}
                className="object-fit-contain position-absolute"
              />
            </div>
            <Table borderless>
              <tbody>
                {dummyApetizers?.map((item, key) => (
                  <tr key={key} style={{ borderBottom: " 1px solid black" }}>
                    <td className="bg-transparent p-0">
                      <p className="f-6 m-0 color-primary-black-5">
                        {item?.title}
                      </p>
                    </td>
                    <td className="bg-transparent p-0  text-end">
                      <p className="f-5 m-0 color-primary-black-5">
                        {item?.price}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
          <Col md={6} xxl={4}>
            3rd column
          </Col>
        </Row> */
}
/*----------------------------------------------------------------*/

export default ResturantMenuCard;
